import { render, staticRenderFns } from "./Filaments.vue?vue&type=template&id=09ed530a"
import script from "./Filaments.vue?vue&type=script&lang=ts"
export * from "./Filaments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports